import { Component, ViewChild } from '@angular/core';
import { InviteService } from './invite.service';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseCRUDComponent } from 'app/Core/Abstract/baseCRUD.component';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
    selector: 'invite',
    templateUrl: 'invite.component.html',
    providers: [InviteService]
})
export class InviteComponent extends BaseCRUDComponent<InviteService>{

    @ViewChild('inviteModal',{static: false}) public inviteModal: ModalDirective;
    public showInviteModal(): void { this.inviteModal.show(); }
    public hideInviteModal(): void { this.inviteModal.hide(); }

    private formErrors = {
        'invEmail':''
    }

    constructor( private service:InviteService, 
        private eventsEmitterService: EventsEmitterService,
        fb: FormBuilder, logger: LogService,  visualsService: VisualsService,
        route: ActivatedRoute, router:Router){

        super(logger, visualsService, route, fb, router);
        this.group = "invite";

        this.loadVisuals();

        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.loadVisuals();
            }
        );
    }

    protected loadBean(map: any){
        console.log('loadBean');
        this.buildForm();
    }

    private buildForm(){

        this.editForm = this.fb.group({
            'invEmail' : [{value: "", disabled:false}, [Validators.required, Validators.email] ]
        });
    
        this.editForm.valueChanges.subscribe(data => this.onValueChanged(data));
    }

    onValueChanged(data?: any) {
        if (!this.editForm) { return; }
        const form = this.editForm;
        
        for (const field in this.editForm.controls) {

            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    protected getValidationMessages(){
        // Use "this.genericVisuals.genericerror" for a generic message

        this.validationMessages = {
            'invEmail': {
                'email': this.genericVisuals.genericerror,
                'required': this.genericVisuals.required
            }
        };  
    };

    protected save(bean:any){
        this.submiting = true;
        this.logger.log(this.editForm.value);

        this.service.save(this.editForm.value['invEmail']).subscribe(
            data => {

                this.submiting = false;

                LogService.emitAlert({
                    type: 'success',
                    body: 'Successful Invitation'
                });

                this.editForm.setValue({invEmail: ""});


            },
            error => {
                this.submiting = false;
                return Observable.throw(error);
            }
        )
    }


}